import React, { useState } from 'react';
import { Layout, Menu, Drawer, Button, Grid, Affix, Col } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom'; // Importar useLocation

const { Header } = Layout;
const { useBreakpoint } = Grid;

// soloInicio: el menú muestra únicamente el botón "Inicio" que vuelve a la home (también se usa en /login)
export const NavbarGeneral = ({ soloInicio = false }) => {
  const location = useLocation(); // Obtener ubicación actual
  const mostrarSoloInicio = soloInicio || location.pathname === '/login';
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => setDrawerVisible(true);
  const onClose = () => setDrawerVisible(false);

  // const handleScroll = (e, id) => {
  //   e.preventDefault();
  //   const element = document.getElementById(id);
  //   if (element) {
  //     const headerHeight = 64;
  //     const elementPosition = element.getBoundingClientRect().top;
  //     const offsetPosition =
  //       elementPosition + window.pageYOffset - headerHeight;

  //     window.scrollTo({
  //       top: offsetPosition,
  //       behavior: "smooth",
  //     });
  //     if (!screens.md) onClose();
  //   }
  // };

  // Dentro del componente...
  const [selectedKey, setSelectedKey] = useState("inicio");

  const handleItemClick = (key, id, e) => {
    e.preventDefault();
    setSelectedKey(key);

    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 72;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      if (!screens.md) onClose();
    }
  };


  const navItems = [
    { key: "inicio", label: "Inicio", id: "inicio" },
    { key: "acerca-de", label: "Acerca de Mundo Piloto", id: "acerca-de" },
    { key: "funcionalidades", label: "Funcionalidades", id: "funcionalidades" },
    { key: "asociaciones", label: "Asociaciones", id: "asociaciones" },
    { key: "contacto", label: "Contacto", id: "contacto" },
  ];
  
  const mappedItemsDesktop = mostrarSoloInicio
  ? [{
      key: 'home',
      label: <Link to="/" style={{ color: '#fff' }}>Inicio</Link>,
    }]
  : navItems.map((item) => ({
      key: item.key,
      label: (
        <a
          href={`/#${item.id}`}
          onClick={(e) => handleItemClick(item.key, item.id, e)}
          className="desktop"
        >
          {item.label}
        </a>
      ),
    }));

const mappedItemsMobile = mostrarSoloInicio
  ? [{
      key: 'home',
      label: <Link to="/" style={{ color: '#000' }}>Inicio</Link>,
    }]
  : navItems.map((item) => ({
      key: item.key,
      label: (
        <a
          href={`/#${item.id}`}
          onClick={(e) => handleItemClick(item.key, item.id, e)}
          className={`mobile ${item.key === selectedKey ? "active-item-mobile" : ""}`}
        >
          {item.label}
        </a>
      ),
    }));

  
  

  return (
    <Affix offsetTop={0}>
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 max(20px, calc((100% - 1280px) / 2 + 20px))',
          height: '72px',
          backgroundColor: '#001529',
          zIndex: 1000,
        }}
      >
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/" style={{ display: "flex", alignItems: "center" }}>
            <img
              src="/img/logo-mundo-piloto.png"
              alt="Logo Asociación"
              style={{ height: "3.4em", objectFit: "contain" }}
            />
          </Link>
        </div>

        {/* Menú en pantallas grandes */}
        {screens.md && (
        <Menu
          mode="horizontal"
          selectedKeys={[selectedKey]}
          items={mappedItemsDesktop}
          style={{
            backgroundColor: 'transparent',
            borderBottom: 'none',
            lineHeight: '64px',
            fontSize: '16px',
            color: '#fff',
            flex: 1,
            justifyContent: 'flex-end',
            display: 'flex',
            gap: '5px',
          }}
        />
        )}


        {/* Botón para menú móvil */}
        {!screens.md && (
          <Button
            className="menu-button"
            type="text"
            icon={<MenuOutlined style={{ color: "#fff", fontSize: "20px" }} />}
            onClick={showDrawer}
          />
        )}

        {/* Drawer para móviles */}
        <Drawer
          title="Menú"
          placement="right"
          closable
          onClose={onClose}
          visible={drawerVisible}
          width={320}
          bodyStyle={{ padding: 0, backgroundColor: '#fff' }} // Fondo blanco
          headerStyle={{ backgroundColor: '#fff', color: '#000' }} // Encabezado blanco y texto negro
        >
          <Menu
            mode="vertical"
            selectedKeys={[selectedKey]}
            items={mappedItemsMobile}
            style={{
              fontSize: "16px",
              padding: '10px 20px',
              backgroundColor: "#fff",
              color: "#000",
            }}
          />
        </Drawer>
      </Header>
    </Affix>
  );
};